import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useState } from 'react';
import Slider from 'react-slick';
var css = {
  "customDots": "oalp-1Vmdk",
  "selectedDot": "oalp-1SKfm"
};
import cx from 'classnames';
export var SliderWrapper = function SliderWrapper(_ref) {
  var children = _ref.children,
    _ref$dots = _ref.dots,
    dots = _ref$dots === void 0 ? true : _ref$dots,
    _ref$arrows = _ref.arrows,
    arrows = _ref$arrows === void 0 ? false : _ref$arrows,
    _ref$dotsClass = _ref.dotsClass,
    dotsClass = _ref$dotsClass === void 0 ? css.customDots : _ref$dotsClass,
    _ref$infinite = _ref.infinite,
    infinite = _ref$infinite === void 0 ? false : _ref$infinite;
  var _useState = useState(0),
    _useState2 = _slicedToArray(_useState, 2),
    currentSlide = _useState2[0],
    setCurrentSlide = _useState2[1];
  var getPage = function getPage(index) {
    return /*#__PURE__*/React.createElement("button", {
      className: cx(_defineProperty({}, css.selectedDot, index === currentSlide))
    }, index + 1);
  };
  var settings = {
    dots: dots,
    arrows: arrows,
    dotsClass: dotsClass,
    infinite: infinite,
    afterChange: function afterChange(index) {
      setCurrentSlide(index);
    },
    customPaging: getPage
  };
  return /*#__PURE__*/React.createElement(Slider, Object.assign({}, settings), children);
};
export default SliderWrapper;